// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1kfVs","head":"Table_head__3jQ1d","col":"Table_col__15CKE"};